const contactnoPattern = /^[6789]{1}\d{9}$/i;
const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const pincodePattern = /^[1-9]{1}[0-9]{2}[0-1][0-9]{2}/;
module.exports = { contactnoPattern, emailPattern, pincodePattern };
